import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../consts/routes";
import { getExam } from "../../services/apiHelpers";

export const useExamCheck = (examId: string, isPractice: boolean) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [blurCount, setBlurCount] = useState(0);

  useEffect(() => {
    if (!examId) {
      navigate(isPractice ? ROUTES.practice : ROUTES.dashboard);
    } else {
      if (isPractice) {
        setIsLoading(false);
      } else {
        checkCompletedAndDisqualified();
      }
    }
  }, [examId]);

  const checkCompletedAndDisqualified = async () => {
    const res = await getExam(examId);
    if (res?.is_completed || res?.is_disqualified) {
      navigate(ROUTES.dashboard);
    } else {
      setBlurCount(res?.window_blur_counter);
      setIsLoading(false);
    }
  };

  return {
    isExamLoading: isLoading,
    blurCount,
    setBlurCount,
  };
};
